import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './download1.module.scss';
import FooterDownloadButtons from '../Footer/components/FooterDownload/FooterDownloadButtons';
import { Download1Type } from '@/types/downloadBlock.types';

const DownloadBlock: NextPage<Download1Type> = ({
  className = '',
  property1 = 'Desktop',
}) => {
  return (
    <section
      className={[styles.download, className].join(' ')}
      data-property1={property1}
    >
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.textandbuttons}>
            <div className={styles.texts}>
              <h2 className={styles.title}>
                Download the Hera Flight mobile app now!
              </h2>
              <div className={styles.descriptor}>
                Get instant access to Hera Flight App&apos;s AI features and
                save time and money now.
              </div>
            </div>
            <div className={styles.buttons}>
              <FooterDownloadButtons />
            </div>
          </div>
          <Image
            className={styles.imgdesktopIcon}
            priority
            width={482}
            height={299}
            sizes="(max-width: 768px) 100vw, 50vw"
            alt=""
            src="/img/downloadBlock/img-1desc.webp"
          />
          <Image
            className={styles.imgtabletIcon}
            priority
            width={1124}
            height={601}
            sizes="(max-width: 768px) 100vw, 50vw"
            alt=""
            src="/img/downloadBlock/img-1desc.webp"
          />
          <Image
            className={styles.imgmobileIcon}
            loading="lazy"
            width={362}
            height={298}
            sizes="(max-width: 768px) 100vw, 50vw"
            alt=""
            src="/img/downloadBlock/img-mob1.webp"
          />
        </div>
      </div>
    </section>
  );
};

export default DownloadBlock;
